import { NutritionalValue } from './NutritionalValue';

export type { TypeNutritionalValueProps } from './types';
export default NutritionalValue;
